var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "700"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', [_vm._v("mdi-book")]), _vm._v(" " + _vm._s(_vm.edit ? "Editar" : "Incluir") + " Material ")], 1)]), _c('div', {
    staticClass: "container dialog"
  }, [_vm.visible ? _c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "justify-center mt-7"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Descrição*",
      "counter": "60",
      "maxlength": "60",
      "dense": "",
      "outlined": "",
      "rules": [function (v) {
        return _vm.$required(v);
      }]
    },
    model: {
      value: _vm.content.descricao,
      callback: function ($$v) {
        _vm.$set(_vm.content, "descricao", $$v);
      },
      expression: "content.descricao"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.listFormacoes,
      "label": "Formação*",
      "item-text": "formacao",
      "item-value": "id",
      "outlined": "",
      "dense": "",
      "rules": [function (v) {
        return _vm.$required(v);
      }]
    },
    model: {
      value: _vm.content.formacao,
      callback: function ($$v) {
        _vm.$set(_vm.content, "formacao", $$v);
      },
      expression: "content.formacao"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sigfoco-upload-file', {
    ref: 'uploadFileComponent_',
    attrs: {
      "size": 12,
      "maxSize": 100,
      "formats": '.pdf, .docx, .png, .jpeg, .jpg, .bmp, .mp3, .mp4, .zip',
      "previewInsideButton": false,
      "label": "Enviar arquivo",
      "position": "left"
    },
    on: {
      "input": _vm.adicionarAnexo
    },
    model: {
      value: _vm.arquivoTemporario,
      callback: function ($$v) {
        _vm.arquivoTemporario = $$v;
      },
      expression: "arquivoTemporario"
    }
  })], 1)], 1), _vm.arquivos.length ? _c('v-row', {
    staticClass: "d-flex justify-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Anexos")]), _c('div', {
    staticClass: "anexos-box"
  }, _vm._l(_vm.arquivos, function (file, index) {
    return _c('div', {
      key: index,
      staticClass: "anexo-item d-flex justify-space-between align-center px-3 py-2"
    }, [_c('span', [_vm._v(" " + _vm._s(file.name || file.nomeExibicao) + " (" + _vm._s(((file.size || file.tamanho) / 1024).toFixed(0)) + "K) ")]), _c('v-icon', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "small": "",
        "color": "grey darken-2"
      },
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.removerAnexo(index);
        }
      }
    }, [_vm._v(" mdi-close ")])], 1);
  }), 0)])], 1) : _vm._e()], 1) : _vm._e()], 1), _c('sigfoco-buttons', {
    attrs: {
      "actionText": "Salvar"
    },
    on: {
      "click": function ($event) {
        return _vm.salvar();
      },
      "cancel": function ($event) {
        return _vm.$emit('onClose');
      }
    }
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }